<template>
    <div>
        <!-- HEADER FOR ALL CLUSTERS -->
        <h1>HEX</h1>
        <h4>HEX is a series of talks from professionals and MIS alumni that caters to the academic and career growth of students who are interested in technology. This year, HEX will be open to all students and topics will branch out to different fields of technology and showcase the various routes students can partake in for their future careers. </h4>

        <!-- POSITIONS -->
        <h3>Positions:</h3>


        <!-- POSITION -->
        <h2><b>Human Resources Project Manager</b></h2>
        
        <ul>
            <li>Human Resources Officers deployed in various MISA projects and events and are tasked to handle the internal relationship of core team members</li>
            <li>Initiate ways in which core team members can bond and develop rapport (e.g. group dynamics and team building</li>
            <li>Conduct individual consultations with their core team members</li>
            <li>Relays messages to and from the HR Board to the Core Team</li>
            <li>In-charge of internal conflict management and resolution</li>
            <li>Conduct post-event core team evaluations with the HR Performance Management System</li>
        
        </ul>

    </div>
</template>

<script>
export default {
    name: 'PrimerOSG'
}
</script>

<style scoped>
h1{
    font-size: 4.5vw;
}
</style>


